export default {
  driedAbaloneSummaries: [],
  driedAbaloneSummary: undefined,
};
